import uniqByLib from 'lodash-es/uniqBy';

export const uniqBy = uniqByLib;
